export default __webpack_public_path__ + "static/media/mirror.3f3c0520.md";